import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const settingsOauthCredentialsRoute: InvariantJiraRoute = {
	name: 'admin-oauth-credentials',
	path: '/secure/admin/oauth-credentials',
};
